<template>
    <modal name="memoList" @before-open="beforeOpen" :adaptive="true" width="100%" height="100%">
        <div class="memo_save_wrap"> 
            <div class="memo_save_cont">
                <h3 class="memotitle">MEMO</h3>
                <div class="memo_search clearfix">
                    <input type="text" placeholder="내용 검색" v-on:keyup.enter="search" v-on:input="search_word = $event.target.value" @keyup="search">
                    <button type="submit"><i class="fa fa-search"></i></button>
                </div>
                <div class="memo_cont_wrap clearfix">
                    <div class="memo_list_btn">
                        <ul>
                            <li><a href="#" @click="selectAll()">전체</a></li>
                            <li v-for="n in contents.chapterCount"><a href="#" @click="selectChapter(n)">{{n}}차시</a></li>
                        </ul>
                    </div>
                    <div class="memo_list_cont clearfix">
                        <ul>
                            <li v-for="memo in search_result" :key="memo.idx">
                                <div class="list_cont">
                                    {{memo.chapter}} 차시
                                </div>
                                <div class="list_cont_btn">
                                    <a href="#" @click="updateMemo(memo)">수정</a>
                                    <a href="#" @click="deleteMemo(memo.idx)">삭제</a>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
                <input type="button" class="memobt" value="닫기" @click="closeModal()"> 
            </div>
        </div>
    </modal>
</template>
<script>
export default {
    props : ['contents'],
    data(){
        return{
            search_word : '',
            search_result : [],
            memos : [],
        }
    },
    methods:{
        closeModal(){
            this.$modal.hide('memoList');
        },
        beforeOpen (event) {
            window.parent.postMessage({
                type : 'studyContetnsMemoGetListRequest',
                // chapter : this.contents.chapterId,
            },'*');
        },
        search: _.throttle( function (){

            if(this.search_word.length >= 1){
                this.search_result = _.filter(this.memos,(item) => {
                    return item.memo.indexOf(this.search_word) > -1;
                });
            }else{
                this.search_result = this.memos;
            }
            
        },100),
        selectAll(){
            this.search_result = this.memos;
        },
        selectChapter(num){
            this.search_result = _.filter(this.memos,(item) => {
                return item.chapter == num;
            });
        },
        deleteMemo(idx){
            swal({
                title: "알림",
                text: "삭제하시겠습니까?",
                icon: "warning",
                buttons: true
            }).then((willDelete) => {
                if (willDelete) {
                    window.parent.postMessage({
                        type : 'studyContetnsMemoDeleteRequest',
                        idx : idx,
                    },'*');
                }
            });
        },
        updateMemo(memo){
            swal({
                title: "알림",
                text: "수정하시겠습니까?",
                icon: "info",
                buttons: true
            }).then((willUpdate) => {
                if (willUpdate) {
                    this.$modal.hide('memoList'); 
                    this.$modal.show('memoUpdate',memo);
                }
            });
        }
    },
    mounted(){
        window.addEventListener("message",(e) => {
            if(e.data.type == "studyContetnsMemoModify"){
                if(e.data.result == 'success'){
                    swal('알림','성공적으로 저장되었습니다.','success');
                }
            }else if(e.data.type == "studyContetnsMemoDeleteResult"){
                if(e.data.response.result == 'success'){
                    let index = _.findIndex(this.memos,(item) => { return item.idx === parseInt(e.data.response.data); });
                    this.memos.splice(index,1);
                    swal('알림','성공적으로 삭제되었습니다.','success');
                }else{
                    swal('알림','서버 에러','error');
                }
            }else if(e.data.type == "studyContetnsMemoGetListRequest"){
                // this.memos = e.data.memos;
            }else if(e.data.type == "studyContetnsMemoGetListResult"){
                this.memos = e.data.memos;
                this.search_result = e.data.memos;
            }
        },false);
    }
}
</script>